import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="13" height="13" xmlns="http://www.w3.org/2000/svg" {...props}><title>icon/arrow-nav-filled-1-1</title><path fill="#D8D8D8" d="M10.5 7l-8 6.5V.5z" fillRule="evenodd" /></svg>);